
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="container mx-auto py-8 px-4">
      <Card className="max-w-4xl mx-auto">
        <CardHeader>
          <CardTitle className="text-3xl">Terms and Conditions</CardTitle>
          <p className="text-gray-500">Effective Date: March 2, 2025</p>
        </CardHeader>
        <CardContent className="prose max-w-none">
          <p>Welcome to CraveSOS! These Terms and Conditions ("Terms") govern your use of the CraveSOS mobile application and related services ("App"). By accessing or using the App, you agree to these Terms. If you do not agree, please do not use the App.</p>
          
          <h2 className="text-xl font-semibold mt-6 mb-2">1. Use of the App</h2>
          <p><strong>1.1 Eligibility:</strong> You must be at least 18 years old to use CraveSOS. If you are under 18, you may use the App with parental consent.</p>
          <p><strong>1.2 License:</strong> We grant you a limited, non-exclusive, non-transferable license to use the App for personal, non-commercial purposes.</p>
          <p><strong>1.3 Prohibited Activities:</strong> You may not:</p>
          <ul className="list-disc pl-6 my-2">
            <li>Use the App for unlawful or fraudulent purposes.</li>
            <li>Interfere with the App's functionality.</li>
            <li>Attempt to reverse-engineer, modify, or resell any part of the App.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2">2. User Accounts</h2>
          <p><strong>2.1 Registration:</strong> To access certain features, you may need to create an account using Google Authentication via Supabase.</p>
          <p><strong>2.2 Account Security:</strong> You are responsible for maintaining the security of your account credentials. We are not liable for any unauthorized access resulting from your failure to secure your account.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">3. Disclaimers and Limitations of Liability</h2>
          <p><strong>3.1 Health Disclaimer:</strong> CraveSOS is not a medical or health service. It provides informational content and tools for managing cravings but should not replace professional medical advice.</p>
          <p><strong>3.2 No Warranties:</strong> We provide the App "as-is" without warranties of any kind, express or implied.</p>
          <p><strong>3.3 Liability Limitation:</strong> To the fullest extent permitted by law, we are not liable for indirect, incidental, or consequential damages arising from your use of the App.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">4. Termination</h2>
          <p><strong>4.1</strong> We reserve the right to suspend or terminate your access if you violate these Terms.</p>
          <p><strong>4.2</strong> You may stop using the App at any time.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">5. Governing Law</h2>
          <p>These Terms shall be governed by the laws of North Carolina, USA.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">6. Changes to These Terms</h2>
          <p>We may update these Terms from time to time. Your continued use of the App after any changes indicates your acceptance.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact Us</h2>
          <p>For questions regarding these Terms, contact us at ryan@maverickinsights.com.</p>
          
          <div className="mt-8 flex justify-center">
            <Link to="/" className="text-blue-600 hover:underline">Back to Home</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Terms;
